export default "__VITE_ASSET__I$jl0Zj3__"